import api from './api';

export const groupApi = {
  // Get all groups
  getGroups: () => api.get('/groups'),

  // Get my groups
  getMyGroups: () => api.get('/groups/my'),

  // Get group by ID
  getGroup: (id) => api.get(`/groups/${id}`),

  // Create group
  createGroup: (data) => api.post('/groups', data),

  // Update group
  updateGroup: (id, data) => api.put(`/groups/${id}`, data),

  // Delete group
  deleteGroup: (id) => api.delete(`/groups/${id}`),

  // Add member
  addMember: (groupId, data) => api.post(`/groups/${groupId}/members`, data),

  // Remove member
  removeMember: (groupId, userId) => api.delete(`/groups/${groupId}/members/${userId}`),

  // Update member role
  updateMemberRole: (groupId, userId, data) => api.put(`/groups/${groupId}/members/${userId}`, data),

  // Add permission
  addPermission: (groupId, data) => api.post(`/groups/${groupId}/permissions`, data),

  // Remove permission
  removePermission: (groupId, permission) => api.delete(`/groups/${groupId}/permissions/${permission}`),

  // Get user's groups
  getUserGroups: (userId) => api.get(`/users/${userId}/groups`),

  // Get all permissions
  getPermissions: () => api.get('/permissions'),

  // Check permission
  checkPermission: (permission) => api.get(`/permissions/check?permission=${permission}`),
};
